import React from 'react';
import { Text } from 'react-native';

import { Col, Grid, Row } from 'components/layout/Grid';
import { addStory } from 'lib/story-books';

import { iconsDictionary } from '.';

addStory('iconsDictionary', () => (
  <Grid>
    {Object.entries(iconsDictionary).map(([name, Component]) => (
      <Row key={name}>
        <Col>
          <Text>{name}</Text>
          <Component />
        </Col>
      </Row>
    ))}
  </Grid>
));
